export interface SelectOption {
  value: string | number;
  label: string;
}

export const TYPE_TO_OS: Record<string, number[]> = {
  mobile: [1, 2],
  desktop: [3, 4, 5],
};

export const DEVICE_TYPE_OPTIONS: SelectOption[] = [
  { value: "all", label: "Tất cả" },
  { value: "mobile", label: "Mobile" },
  { value: "desktop", label: "Desktop" },
];

export const OS_OPTIONS: SelectOption[] = [
  { value: "all", label: "Tất cả hệ điều hành" },
  { value: 1, label: "Android" },
  { value: 2, label: "iOS" },
  { value: 3, label: "Windows" },
  { value: 4, label: "Linux" },
  { value: 5, label: "MacOS" },
];

export const VERSION_OPTIONS: SelectOption[] = [
  { value: "all", label: "Tất cả phiên bản" },
];

export const ITEMS_PER_PAGE = 10;

export const DEVICE_TAB_ACTIVE = "active";
export const DEVICE_TAB_BLOCKED = "blocked";
export type DeviceTab = typeof DEVICE_TAB_ACTIVE | typeof DEVICE_TAB_BLOCKED;
